import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { ArchiveRestore, Mail } from "lucide-react";
import { useState, useEffect } from "react";

interface ReactivateSessionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (params: { sendEmail: boolean }) => void;
  isPending?: boolean;
}

export function ReactivateSessionDialog({
  open,
  onOpenChange,
  onConfirm,
  isPending = false,
}: ReactivateSessionDialogProps) {
  const [sendEmail, setSendEmail] = useState(true);

  // Reset state when dialog closes
  useEffect(() => {
    if (!open) {
      setSendEmail(true);
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ArchiveRestore className="h-5 w-5 text-green-600" />
            Termin reaktivieren
          </DialogTitle>
          <DialogDescription>
            Der abgesagte Termin wird wieder aktiviert. Sie können optional alle Teilnehmer per E-Mail und SMS benachrichtigen.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="flex items-center justify-between rounded-lg border p-4">
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-muted-foreground" />
              <div className="space-y-0.5">
                <Label htmlFor="sendReactivateEmail">Teilnehmer benachrichtigen</Label>
                <p className="text-sm text-muted-foreground">
                  E-Mail-Benachrichtigung an alle Teilnehmer senden (SMS nur an Teilnehmer mit Einwilligung)
                </p>
              </div>
            </div>
            <Switch
              id="sendReactivateEmail"
              checked={sendEmail}
              onCheckedChange={setSendEmail}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Abbrechen
          </Button>
          <Button
            className="bg-green-600 hover:bg-green-700"
            onClick={() => onConfirm({ sendEmail })}
            disabled={isPending}
          >
            {isPending ? "Wird reaktiviert..." : "Termin reaktivieren"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
